"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4907],{

/***/ 40026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jc": function() { return /* binding */ AssetWithdrawalContext; },
  "b2": function() { return /* binding */ AssetWithdrawalProvider; }
});

// UNUSED EXPORTS: initValue

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@orca-so/common-sdk/dist/index.js
var dist = __webpack_require__(66259);
// EXTERNAL MODULE: ./node_modules/@solana/spl-token/lib/index.browser.esm.js + 5 modules
var index_browser_esm = __webpack_require__(974);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js + 3 modules
var lib_index_browser_esm = __webpack_require__(27632);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-balances.ts
var use_balances = __webpack_require__(68203);
// EXTERNAL MODULE: ./src/hooks/use-deposit-token-options.ts
var use_deposit_token_options = __webpack_require__(74733);
// EXTERNAL MODULE: ./src/hooks/use-nemo-wallet.ts
var use_nemo_wallet = __webpack_require__(6200);
// EXTERNAL MODULE: ./src/hooks/use-safely-send-tx-with-notice.tsx + 1 modules
var use_safely_send_tx_with_notice = __webpack_require__(76243);
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
;// CONCATENATED MODULE: ./src/utils/cypress-support/utils.ts




const utils_parseFloat = (value)=>toDecimal(value).toNumber();
const toFixed = (param)=>{
    let { value , decimals , rounding  } = param;
    return format(value, {
        decimals,
        rounding
    });
};
const toU64 = function(number) {
    let decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return dist.DecimalUtil.toU64(new decimal/* default */.Z(number).toDP(decimals), decimals);
};
const formatError = (err)=>"> ".concat(err.message, "\n\n").concat(err.logs && err.logs.length ? "Transaction logs:\n- ".concat(err.logs.join("\n- "), "\n\n") : "", "Stack trace:\n").concat(err.stack);
/**
 * Wraps a task function to be called from `cy.retryableTask`.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const retryable = (fn)=>{
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            const result = fn(...args);
            return result instanceof Promise ? result.then((result)=>({
                    retry: false,
                    result
                }), (reason)=>({
                    retry: true,
                    error: formatError(reason)
                })) : {
                retry: false,
                result
            };
        } catch (error) {
            return {
                retry: true,
                error: formatError(error)
            };
        }
    };
};
/**
 * Recomposes the list of tasks by turning some into {@link retryable}s and
 * attach {@link healer}s to all.
 */ const buildTasksObject = (param)=>{
    let { tasks , retryables =[] , pills =[]  } = param;
    const withHealer = healer(...pills);
    return Object.fromEntries(Object.entries(tasks).map((param)=>{
        let [task, fn] = param;
        return [
            task,
            retryables.includes(task) ? retryable(withHealer(fn)) : withHealer(fn)
        ];
    }));
};

// EXTERNAL MODULE: ./src/wallet/adapter.ts + 1 modules
var adapter = __webpack_require__(33618);
;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/utils.ts
const NETWORK_RENEC = "RENEC Network";
const renecNetworkOption = {
    chain_name: NETWORK_RENEC,
    chain_name_abbr: NETWORK_RENEC
};
// to be fetched from API in the future
// Note: RENEC should be first of the list
const networkOptions = [
    renecNetworkOption
];

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/context.tsx












const initValue = {
    selectedToken: null,
    setSelectedToken: ()=>null,
    submitWithdrawByRenecNetwork: ()=>Promise.resolve(),
    currentTokenBalance: 0,
    isSubmitSucceeded: false,
    setIsSubmitSucceeded: ()=>null,
    isLoading: false,
    tokenOptions: [],
    networkOptions: []
};
const AssetWithdrawalContext = /*#__PURE__*/ (0,react.createContext)(initValue);
const AssetWithdrawalProvider = (param)=>{
    let { children  } = param;
    const { balances  } = (0,use_balances/* useBalances */.l)();
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { anchorWallet , publicKey: senderWalletPubkey  } = (0,use_nemo_wallet/* default */.Z)();
    const { safelySendTxWithNotice  } = (0,use_safely_send_tx_with_notice/* default */.Z)("make_asset_withdrawal");
    const { tokenOptions , isLoading: isLoadingTokenOptions  } = (0,use_deposit_token_options/* default */.Z)();
    const [selectedToken, setSelectedToken] = (0,react.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
    const [isSubmitSucceeded, setIsSubmitSucceeded] = (0,react.useState)(false);
    const isLoading = isLoadingTokenOptions || isSubmitting;
    const currentTokenBalance = (0,react.useMemo)(()=>{
        const tokenSymbol = selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.symbol;
        if (!tokenSymbol) {
            return 0;
        }
        return (balances === null || balances === void 0 ? void 0 : balances[tokenSymbol]) || 0;
    }, [
        balances,
        selectedToken
    ]);
    (0,react.useEffect)(()=>{
        if (!selectedToken) {
            setIsSubmitting(false);
            setIsSubmitSucceeded(false);
        }
    }, [
        selectedToken
    ]);
    const submitWithdrawByRenecNetwork = (0,react.useCallback)(async (toWalletAddress, tokenAmount)=>{
        if (isSubmitting) return;
        setIsSubmitting(true);
        if (!selectedToken) {
            throw Error("[assets:withdraw] no token info");
        }
        if (!senderWalletPubkey || !toWalletAddress) {
            throw Error("[assets:withdraw] missing wallet addresses");
        }
        if (!tokenAmount) {
            throw Error("[assets:withdraw] input amount");
        }
        const tokenMintPubkey = new lib_index_browser_esm.PublicKey(selectedToken.address);
        const fromWallet = senderWalletPubkey;
        const toWallet = new lib_index_browser_esm.PublicKey(toWalletAddress);
        const txBuilder = new dist.TransactionBuilder(connection, anchorWallet);
        if (tokenMintPubkey.equals(index_browser_esm.NATIVE_MINT)) {
            txBuilder.addInstruction({
                cleanupInstructions: [],
                instructions: [
                    lib_index_browser_esm.SystemProgram.transfer({
                        fromPubkey: fromWallet,
                        toPubkey: toWallet,
                        lamports: toU64(tokenAmount, selectedToken.decimals).toNumber()
                    })
                ],
                signers: []
            });
        } else {
            const senderATA = await index_browser_esm.Token.getAssociatedTokenAddress(index_browser_esm.ASSOCIATED_TOKEN_PROGRAM_ID, index_browser_esm.TOKEN_PROGRAM_ID, tokenMintPubkey, fromWallet);
            const receiverATA = await index_browser_esm.Token.getAssociatedTokenAddress(index_browser_esm.ASSOCIATED_TOKEN_PROGRAM_ID, index_browser_esm.TOKEN_PROGRAM_ID, tokenMintPubkey, toWallet, true);
            // Initialize receiverATA if not yet created.
            const receiverATAInfo = await connection.getAccountInfo(receiverATA);
            if (!receiverATAInfo) {
                txBuilder.addInstruction({
                    cleanupInstructions: [],
                    instructions: [
                        index_browser_esm.Token.createAssociatedTokenAccountInstruction(index_browser_esm.ASSOCIATED_TOKEN_PROGRAM_ID, index_browser_esm.TOKEN_PROGRAM_ID, tokenMintPubkey, receiverATA, toWallet, fromWallet)
                    ],
                    signers: []
                });
            }
            txBuilder.addInstruction({
                cleanupInstructions: [],
                instructions: [
                    index_browser_esm.Token.createTransferInstruction(index_browser_esm.TOKEN_PROGRAM_ID, senderATA, receiverATA, fromWallet, [], toU64(tokenAmount, selectedToken.decimals).toNumber())
                ],
                signers: []
            });
        }
        const txid = await safelySendTxWithNotice(txBuilder);
        if (txid) {
            setIsSubmitSucceeded(true);
        }
        setIsSubmitting(false);
    }, [
        selectedToken,
        anchorWallet,
        connection,
        isSubmitting,
        senderWalletPubkey,
        safelySendTxWithNotice
    ]);
    const ctxValue = (0,react.useMemo)(()=>({
            selectedToken,
            setSelectedToken,
            currentTokenBalance,
            submitWithdrawByRenecNetwork,
            isLoading,
            isSubmitSucceeded,
            setIsSubmitSucceeded,
            tokenOptions,
            networkOptions: networkOptions
        }), [
        selectedToken,
        setSelectedToken,
        currentTokenBalance,
        submitWithdrawByRenecNetwork,
        isLoading,
        isSubmitSucceeded,
        setIsSubmitSucceeded,
        tokenOptions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetWithdrawalContext.Provider, {
        value: ctxValue,
        children: children
    });
};


/***/ }),

/***/ 67428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ModalTokensFlow_container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(80437);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/ModalLayout/index.ts + 1 modules
var ModalLayout = __webpack_require__(57606);
// EXTERNAL MODULE: ./src/hooks/use-nemo-wallet.ts
var use_nemo_wallet = __webpack_require__(6200);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 2 modules
var useTrans = __webpack_require__(74069);
// EXTERNAL MODULE: ./src/components/base/WrappedTokensFlow/context.tsx
var context = __webpack_require__(96661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/base/Button/index.tsx
var Button = __webpack_require__(10737);
;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowConnectWallet/index.tsx







const FlowConnectWallet = (param)=>{
    let { onClick  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const { connectWallet  } = (0,use_nemo_wallet/* default */.Z)();
    const { selectedToken  } = (0,react.useContext)(context/* WrappedTokensFlowContext */.H$);
    const handleClick = ()=>{
        connectWallet();
        onClick();
    };
    if (!selectedToken) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm font-semibold mb-[24px]",
                children: trans.wrapped_token.you_can_trade(selectedToken.displaySymbol)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: handleClick,
                variant: "outlined",
                size: "xl",
                fullWidth: true,
                "data-testid": "flow-connect-token-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-gradient",
                    children: trans.common.connect_wallet
                })
            })
        ]
    });
};
/* harmony default export */ var WrappedTokensFlow_FlowConnectWallet = (FlowConnectWallet);

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/utils/apis/index.ts
var apis = __webpack_require__(40795);
;// CONCATENATED MODULE: ./src/hooks/use-deposit-networks.ts


const useDepositNetworks = ()=>(0,es.useQuery)({
        queryKey: [
            "networkOptions"
        ],
        queryFn: async ()=>{
            const { data  } = await apis/* api.get */.h.get("/crosschain_coin_transfer/deposit_networks");
            ;
            return data;
        },
        refetchOnWindowFocus: false
    });

// EXTERNAL MODULE: ./src/hooks/use-toast-message.tsx + 1 modules
var use_toast_message = __webpack_require__(36625);
;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositCode/utils.ts

const NETWORK_RENEC = "RENEC Network";
const renecNetworkOption = {
    chain_name: NETWORK_RENEC,
    chain_name_abbr: NETWORK_RENEC,
    layer_name: "",
    layer_key: ""
};
const generateDepositAddresses = async (publicKey, network)=>{
    try {
        const { data  } = await apis/* api.get */.h.get("/deposit_addresses", {
            params: {
                layer: network.layer_key,
                address: publicKey
            }
        });
        // Fake data to test on local
        // return {
        //   address: '0x57c65bc931c462d5c9a1f37cc278979e4abad309' + Date.now().toString(),
        //   layer: layerByNetworkMap[network],
        //   renec_wallet: publicKey,
        // }
        if (!data) throw new Error("");
        return data;
    } catch (err) {
        return null;
    }
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ExpandMore.js
var ExpandMore = __webpack_require__(6571);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(23599);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button_Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 5 modules
var Menu = __webpack_require__(93419);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-qrcode/dist/next-qrcode.es.js
var next_qrcode_es = __webpack_require__(59496);
// EXTERNAL MODULE: ./src/utils/static-import-icon.tsx + 42 modules
var static_import_icon = __webpack_require__(61930);
;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositCode/AddressWithCode.tsx








const AddressWithCode = (param)=>{
    let { address , loading  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const { Canvas  } = (0,next_qrcode_es/* useQRCode */.y)();
    const [isCopied, setIsCopied] = (0,react.useState)(false);
    const handleClickCopy = (0,react.useCallback)((evt)=>{
        evt.stopPropagation();
        setIsCopied(true);
        navigator.clipboard.writeText(address);
        setTimeout(()=>{
            setIsCopied(false);
        }, 2000);
    }, [
        address
    ]);
    if (!address) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm pb-4 pt-2 text-center",
                children: trans.wrapped_token.to_address_below
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "center",
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classnames_default()("w-[172px] h-[172px] overflow-hidden rounded-[8px]", {
                            "opacity-50": loading
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Canvas, {
                            text: address,
                            options: {
                                level: "M",
                                scale: 0,
                                width: 172,
                                margin: 2
                            }
                        })
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[1]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: "3rem"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                className: "rounded-[8px] border border-[#3A3F5D] border-solid bg-[#060814] p-1 min-h-[44px] mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-sm p-1 break-all flex-1",
                        children: address
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                        onClick: handleClickCopy,
                        "data-testid": "btn-copy",
                        className: "normal-case text-sm font-semibold color-[#E7E8EB] gap-2 rounded-[4px] bg-[#1A2330] whitespace-nowrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.COPY */.u.COPY),
                                alt: "copy",
                                width: 20,
                                className: "cursor-pointer min-w-[20px]"
                            }),
                            isCopied ? trans.common.copied : trans.common.copy
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FlowDepositCode_AddressWithCode = (/*#__PURE__*/(0,react.memo)(AddressWithCode));

// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositCode/SelectTokenItem.tsx



const SelectTokenItem = (param)=>{
    let { token  } = param;
    if (!token) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        className: "pl-2 py-2 pr-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                src: token.logoURI,
                alt: token.displaySymbol,
                width: "24px",
                height: "24px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm font-bold",
                children: token.displaySymbol
            })
        ]
    }, token.symbol);
};
/* harmony default export */ var FlowDepositCode_SelectTokenItem = (SelectTokenItem);

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositCode/styles.ts
const selectStyles = {
    ".MuiSelect-select": {
        paddingTop: 0,
        paddingBottom: 0
    },
    "&::after": {
        content: "none"
    },
    "&::before": {
        content: "none"
    }
};

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositCode/view.tsx










const View = (param)=>{
    let { selectedToken , selectedNetwork , onChangeToken , isOpenMenu , setIsOpenMenu , networkOptions , isLoading , onChangeNetwork , addressToGenQR , onNext , tokenOptions  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const anchorElRef = (0,react.useRef)(null);
    const isShowMenuNetwork = networkOptions.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-sm",
                        "data-testid": "desc-from-platform",
                        children: trans.wrapped_token.please_send
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                        variant: "standard",
                        sx: selectStyles,
                        IconComponent: ExpandMore/* default */.Z,
                        value: selectedToken.symbol,
                        onChange: onChangeToken,
                        className: "rounded-[80px] overflow-hidden",
                        renderValue: (symbol)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowDepositCode_SelectTokenItem, {
                                token: tokenOptions.find((tokenOpt)=>tokenOpt.symbol === symbol)
                            });
                        },
                        "data-testid": "select-coin",
                        children: tokenOptions.map((token)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: token.symbol,
                                className: "p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowDepositCode_SelectTokenItem, {
                                    token: token
                                })
                            }, token.symbol))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                className: "my-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-sm",
                        children: trans.wrapped_token.through_network
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                        ref: anchorElRef,
                        onClick: ()=>isShowMenuNetwork && setIsOpenMenu(true),
                        className: classnames_default()("cursor-pointer normal-case rounded-[8px] pl-3 pr-1", {
                            "bg-gradient-btn": !selectedNetwork
                        }),
                        "data-testid": "btn-select-network",
                        children: [
                            selectedNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "text-sm font-bold",
                                children: [
                                    selectedNetwork.chain_name_abbr,
                                    " ",
                                    selectedNetwork.layer_name && "(".concat(selectedNetwork.layer_name, ")")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm",
                                children: trans.wrapped_token.select_network
                            }),
                            isShowMenuNetwork && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
                        ]
                    }),
                    isShowMenuNetwork && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        anchorEl: anchorElRef.current,
                        open: isOpenMenu,
                        onClose: ()=>setIsOpenMenu(false),
                        children: networkOptions.map((network)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: network.chain_name,
                                className: "p-0",
                                onClick: ()=>onChangeNetwork(network),
                                "data-testid": "menu-network-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    className: "px-3 py-2 text-sm font-bold",
                                    children: [
                                        network.chain_name,
                                        " ",
                                        network.layer_name && "(".concat(network.layer_name, ")")
                                    ]
                                })
                            }, network.chain_name))
                    })
                ]
            }),
            !addressToGenQR && isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "center",
                className: "py-6",
                "data-testid": "circular-progress",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    size: "3rem"
                })
            }),
            addressToGenQR && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowDepositCode_AddressWithCode, {
                        address: addressToGenQR,
                        loading: isLoading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onNext,
                        loading: isLoading,
                        "data-testid": "btn-confirm-deposit",
                        size: "xl",
                        className: "mt-5",
                        children: trans.wrapped_token.btn_deposited(selectedToken.displaySymbol)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var view = (/*#__PURE__*/(0,react.memo)(View));

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositCode/container.tsx









const Container = (param)=>{
    let { onNext  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const { showMessage  } = (0,use_toast_message/* default */.Z)();
    const timeoutRef = (0,react.useRef)(null);
    const { publicKey  } = (0,use_nemo_wallet/* default */.Z)();
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [isOpenMenu, setIsOpenMenu] = (0,react.useState)(false);
    const [addressToGenQR, setAddressToGenQR] = (0,react.useState)("");
    const [selectedNetwork, setSelectedNetwork] = (0,react.useState)();
    const { selectedToken , setSelectedToken , tokenOptions  } = (0,react.useContext)(context/* WrappedTokensFlowContext */.H$);
    const { data: depositNetworks  } = useDepositNetworks();
    (0,react.useEffect)(()=>{
        if (!publicKey || !selectedToken) return;
        if (!selectedNetwork) return;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (selectedNetwork.chain_name === renecNetworkOption.chain_name) {
            setAddressToGenQR(publicKey.toString());
            return;
        }
        setIsLoading(true);
        timeoutRef.current = setTimeout(async ()=>{
            const response = await generateDepositAddresses(publicKey.toString(), selectedNetwork);
            if (!response || !response.address) {
                showMessage({
                    txid: "",
                    type: "error",
                    title: trans.common.failed,
                    message: trans.common.something_wrong
                });
            } else {
                setAddressToGenQR(response.address);
            }
            setIsLoading(false);
        }, 300);
    }, [
        publicKey,
        selectedNetwork,
        selectedToken,
        showMessage,
        trans
    ]);
    (0,react.useEffect)(()=>{
        if (!publicKey || !selectedToken) return;
        if (selectedToken.symbol === "RENEC") {
            setAddressToGenQR(publicKey.toString());
            setSelectedNetwork(renecNetworkOption);
        }
    }, [
        selectedToken,
        publicKey
    ]);
    const networkOptions = (0,react.useMemo)(()=>{
        let filteredDepositNetworks = [];
        if ((selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.displaySymbol) && depositNetworks) {
            filteredDepositNetworks = depositNetworks[selectedToken.displaySymbol.toLowerCase()];
        }
        return [
            renecNetworkOption
        ].concat(filteredDepositNetworks).filter(Boolean);
    }, [
        depositNetworks,
        selectedToken
    ]);
    const onChangeToken = (0,react.useCallback)((evt)=>{
        const token = tokenOptions.find((tokenOpt)=>tokenOpt.symbol === evt.target.value);
        if (token) {
            setSelectedToken(token);
        }
    }, [
        setSelectedToken,
        tokenOptions
    ]);
    const onChangeNetwork = (0,react.useCallback)((network)=>{
        setSelectedNetwork(network);
        setIsOpenMenu(false);
    }, []);
    if (!selectedToken) return null;
    const injectedProps = {
        selectedToken,
        selectedNetwork,
        onChangeToken,
        isOpenMenu,
        setIsOpenMenu,
        networkOptions,
        isLoading,
        onChangeNetwork,
        addressToGenQR,
        onNext,
        tokenOptions
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(view, {
        ...injectedProps
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositCode/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircle.js
var CheckCircle = __webpack_require__(60888);
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./src/hooks/use-balances.ts
var use_balances = __webpack_require__(68203);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositConfirm/container.tsx









const container_Container = (param)=>{
    let { onNext  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const { balances  } = (0,use_balances/* useBalances */.l)();
    const { selectedToken , prevTokenBalance  } = (0,react.useContext)(context/* WrappedTokensFlowContext */.H$);
    const [isLoadingDelay, setIsLoadingDelay] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        /**
     * Delay a bit to show CircularProgress in the case users click on the button `I have deposited USDT`
     *  after the balance is changed already
     */ setTimeout(()=>{
            setIsLoadingDelay(false);
        }, 300);
    }, []);
    const latestTokenBalance = (0,react.useMemo)(()=>{
        if (!selectedToken) return 0;
        return balances[selectedToken.symbol] || 0;
    }, [
        balances,
        selectedToken
    ]);
    if (!selectedToken) return null;
    const balanceIncrementAmount = new decimal/* default */.Z(latestTokenBalance).sub(new decimal/* default */.Z(prevTokenBalance));
    const isConfirmed = balanceIncrementAmount.greaterThan(0);
    const isShowSpinner = !isConfirmed || isLoadingDelay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: "text-sm leading-[28px]",
                children: [
                    trans.wrapped_token.please_wait_the_transaction,
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "underline font-semibold cursor-pointer",
                        onClick: onNext,
                        "data-testid": "btn-learn-more",
                        children: trans.wrapped_token.learn_more
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "8px",
                className: "py-3 mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        gap: "4px",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "text-base font-semibold whitespace-nowrap",
                                "data-testid": "your-balance",
                                children: [
                                    trans.wrapped_token.your_balance,
                                    ":",
                                    " ",
                                    (0,numeric/* formatSafe */.g1)(latestTokenBalance, selectedToken.decimals),
                                    " ",
                                    isShowSpinner && selectedToken.symbol,
                                    " "
                                ]
                            }),
                            !isShowSpinner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "font-semibold whitespace-nowrap",
                                "data-testid": "your-balance-increment",
                                children: [
                                    "(",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#54B762]",
                                        children: (0,numeric/* formatSafe */.g1)(balanceIncrementAmount, selectedToken.decimals, {
                                            sign: true
                                        })
                                    }),
                                    " ",
                                    selectedToken.symbol,
                                    ") "
                                ]
                            })
                        ]
                    }),
                    isShowSpinner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: "48px"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                        className: "w-[58px] h-[58px] text-[#54B762]"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FlowDepositConfirm_container = (container_Container);

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowDepositConfirm/index.ts


;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowWrappingInfo/container.tsx






const FlowWrappingInfo_container_Container = (param)=>{
    let { onClose  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const { selectedToken  } = (0,react.useContext)(context/* WrappedTokensFlowContext */.H$);
    if (!selectedToken) return null;
    const tokenSymbol = selectedToken.symbol;
    const displaySymbol = selectedToken.displaySymbol;
    const urlUnwrapToken = "https://wrap.renec.org/unwrap-token/".concat(selectedToken.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm",
                children: trans.wrapped_token.info_wrapped_token(displaySymbol, tokenSymbol)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: "text-sm mt-3",
                children: [
                    trans.wrapped_token.info_unwrap_token(displaySymbol, tokenSymbol),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: urlUnwrapToken,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: urlUnwrapToken
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: onClose,
                "data-testid": "btn-close",
                className: "mt-6",
                variant: "outlined",
                size: "xl",
                fullWidth: true,
                children: trans.wrapped_token.btn_got_it
            })
        ]
    });
};
/* harmony default export */ var FlowWrappingInfo_container = (FlowWrappingInfo_container_Container);

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/FlowWrappingInfo/index.ts


;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/ModalTokensFlow/utils.ts
const STEP_CONNECT_WALLET = "ConnectWallet";
const STEP_QR_CODE = "DepositCode";
const STEP_CONFIRM = "DepositConfirm";
const STEP_WRAPPING_INFO = "DepositWrappingInfo";

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/ModalTokensFlow/container.tsx












const classesDialog = {
    root: "outline-none p-0 h-full"
};
const ModalTokensFlow_container_Container = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const { publicKey  } = (0,use_nemo_wallet/* default */.Z)();
    const [flowStep, setFlowStep] = (0,react.useState)(!publicKey ? STEP_CONNECT_WALLET : STEP_QR_CODE);
    const { selectedToken , setSelectedToken  } = (0,react.useContext)(context/* WrappedTokensFlowContext */.H$);
    const isOpenModal = Boolean(selectedToken);
    (0,react.useEffect)(()=>{
        if (!isOpenModal) {
            setFlowStep(!publicKey ? STEP_CONNECT_WALLET : STEP_QR_CODE);
            setSelectedToken(null);
        }
    }, [
        publicKey,
        isOpenModal,
        setSelectedToken
    ]);
    const modalTitle = (0,react.useMemo)(()=>{
        if (!selectedToken) return "";
        const displaySymbol = selectedToken.displaySymbol;
        return ({
            [STEP_CONNECT_WALLET]: trans.wrapped_token.title.you_have_token(displaySymbol),
            [STEP_QR_CODE]: trans.wrapped_token.title.step_to_deposit(displaySymbol),
            [STEP_CONFIRM]: trans.wrapped_token.title.wait_to_confirm,
            [STEP_WRAPPING_INFO]: trans.wrapped_token.title.wrapping_token(displaySymbol)
        })[flowStep];
    }, [
        trans,
        selectedToken,
        flowStep
    ]);
    const handleCloseModal = (0,react.useCallback)(()=>{
        setSelectedToken(null);
    }, [
        setSelectedToken
    ]);
    const handleGoToConfirm = (0,react.useCallback)(()=>{
        setFlowStep(STEP_CONFIRM);
    }, []);
    const handleGoToStepInfo = (0,react.useCallback)(()=>{
        setFlowStep(STEP_WRAPPING_INFO);
    }, []);
    const hasBottomCloseBtn = [
        STEP_QR_CODE,
        STEP_CONFIRM
    ].includes(flowStep);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: isOpenModal,
        onClose: handleCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
            classes: classesDialog,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalLayout/* default */.Z, {
                title: modalTitle,
                onClose: handleCloseModal,
                isDisplayBtnClose: hasBottomCloseBtn,
                footer: trans.common.powered_by_remitano,
                children: [
                    flowStep === STEP_CONNECT_WALLET && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedTokensFlow_FlowConnectWallet, {
                        onClick: handleCloseModal
                    }),
                    flowStep === STEP_QR_CODE && /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
                        onNext: handleGoToConfirm
                    }),
                    flowStep === STEP_CONFIRM && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowDepositConfirm_container, {
                        onNext: handleGoToStepInfo
                    }),
                    flowStep === STEP_WRAPPING_INFO && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowWrappingInfo_container, {
                        onClose: handleCloseModal
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ModalTokensFlow_container = (ModalTokensFlow_container_Container);

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/ModalTokensFlow/index.tsx



/***/ }),

/***/ 57606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/base/Button/index.tsx
var Button = __webpack_require__(10737);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 2 modules
var useTrans = __webpack_require__(74069);
;// CONCATENATED MODULE: ./src/components/common/ModalLayout/container.tsx






const Container = (param)=>{
    let { children , title , onClose , isDisplayBtnClose , footer , isInsideDrawer , customWidthClasses  } = param;
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        className: classnames_default()("bg-[#1E2735] iw:bg-white text-white iw:text-[#000E0F] rounded-[16px]", {
            "rounded-b-none": isInsideDrawer,
            ["".concat(customWidthClasses || "w-[343px] sm:w-[484px]", " max-h-[90vh] overflow-auto absolute top-1/2	left-1/2 translate-x-[-50%] translate-y-[-50%]")]: !isInsideDrawer
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "px-6 py-[11px] bg-[#1A2330] iw:bg-[#F6FBFF] rounded-t-[16px]",
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-xl font-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {
                        className: "cursor-pointer",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "p-6",
                children: [
                    children,
                    isDisplayBtnClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        "data-testid": "btn-close",
                        className: "mt-[12px]",
                        fullWidth: true,
                        variant: "outlined",
                        size: "xl",
                        children: trans.wrapped_token.btn_close
                    }),
                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-xs text-gray-500 mt-2 relative top-2",
                        children: footer
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/components/common/ModalLayout/index.ts



/***/ }),

/***/ 63811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ METHOD_TYPE; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Clear__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63343);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99226);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6514);
/* harmony import */ var _mui_material_Drawer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58826);
/* harmony import */ var _mui_material_Modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80437);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26447);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98396);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74069);













const METHOD_TYPE = {
    network: "network",
    bank: "bank",
    swapOthers: "swapOthers"
};
const classesDialog = {
    root: "outline-none p-0 h-full"
};
const MethodSelectionDialog = (param)=>{
    let { onClose , onClick , selectedDepositToken , selectedWithdrawToken , isP2pSupported  } = param;
    const trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const isDesktop = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(theme.breakpoints.up("sm"));
    const isOpenDialog = Boolean(selectedDepositToken || selectedWithdrawToken);
    const tokenSymbol = (selectedDepositToken === null || selectedDepositToken === void 0 ? void 0 : selectedDepositToken.symbol) || (selectedWithdrawToken === null || selectedWithdrawToken === void 0 ? void 0 : selectedWithdrawToken.symbol);
    const tokenDisplaySymbol = (selectedDepositToken === null || selectedDepositToken === void 0 ? void 0 : selectedDepositToken.displaySymbol) || (selectedWithdrawToken === null || selectedWithdrawToken === void 0 ? void 0 : selectedWithdrawToken.displaySymbol);
    const methodOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (!tokenSymbol) return [];
        const isSupportMethod = isP2pSupported(tokenSymbol);
        return selectedWithdrawToken ? [
            {
                title: isSupportMethod ? trans.core_tokens_list.bank.withdraw : trans.core_tokens_list.others.withdraw,
                description: isSupportMethod ? trans.core_tokens_list.bank.description : trans.core_tokens_list.others.description(tokenSymbol, true),
                type: METHOD_TYPE.bank,
                dataTestID: "method-selection-bank",
                icon: "/assets-to-bank-icon.png"
            },
            {
                title: trans.core_tokens_list.network.withdraw,
                description: trans.core_tokens_list.network.description,
                type: METHOD_TYPE.network,
                dataTestID: "method-selection-network",
                icon: "/assets-to-others-icon.png"
            }
        ] : [
            {
                title: isSupportMethod ? trans.core_tokens_list.bank.deposit : trans.core_tokens_list.others.deposit(tokenSymbol),
                description: isSupportMethod ? trans.core_tokens_list.bank.description : trans.core_tokens_list.others.description(tokenSymbol, false),
                type: METHOD_TYPE.bank,
                dataTestID: "method-selection-bank",
                icon: isSupportMethod ? "/assets-from-bank-icon.png" : "/assets-swap-icon.png"
            },
            {
                title: trans.core_tokens_list.network.deposit,
                description: trans.core_tokens_list.network.description,
                type: METHOD_TYPE.network,
                dataTestID: "method-selection-network",
                icon: "/assets-from-others-icon.png"
            }
        ];
    }, [
        tokenSymbol,
        selectedWithdrawToken,
        trans,
        isP2pSupported
    ]);
    const renderedContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: "bg-[#1E2735] text-white rounded-[16px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "space-between",
                className: "px-6 py-[11px] bg-[#1A2330] rounded-t-[16px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: "text-base font-bold",
                        children: [
                            selectedDepositToken ? trans.common.deposit : trans.common.withdraw,
                            " ",
                            tokenDisplaySymbol
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Clear__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        className: "cursor-pointer",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "px-4 py-6",
                gap: "8px",
                children: methodOptions.map((method)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        gap: "8px",
                        direction: "row",
                        alignItems: "center",
                        className: "bg-[#141A23] py-5 px-4 rounded-lg cursor-pointer",
                        onClick: ()=>onClick(method.type),
                        "data-testid": method.dataTestID,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: method.title,
                                src: method.icon,
                                className: "object-cover",
                                width: 40,
                                height: 40
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        className: "text-base font-semibold",
                                        children: method.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        className: "text-[#9CA3AE] text-sm",
                                        children: method.description
                                    })
                                ]
                            })
                        ]
                    }, method.type))
            })
        ]
    });
    if (isDesktop) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            open: isOpenDialog,
            onClose: onClose,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                classes: classesDialog,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "w-[343px] sm:w-[484px] max-h-[90vh] overflow-auto absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]",
                    children: renderedContent
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Drawer__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
        open: isOpenDialog,
        onClose: onClose,
        anchor: "bottom",
        sx: {
            ".MuiPaper-elevation": {
                backgroundColor: "transparent",
                backgroundImage: "none"
            }
        },
        children: renderedContent
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(MethodSelectionDialog));


/***/ }),

/***/ 65932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_base_AssetWithdrawal_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40026);
/* harmony import */ var _components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96661);
/* harmony import */ var _components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63811);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28309);







const useAssetsMethodSelectionFlow = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { fiatTokensList  } = (0,_hooks_use_tokens__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Co)();
    const { setSelectedToken: setWithdrawToken  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_base_AssetWithdrawal_context__WEBPACK_IMPORTED_MODULE_3__/* .AssetWithdrawalContext */ .jc);
    const { setSelectedToken: setDepositToken  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_4__/* .WrappedTokensFlowContext */ .H$);
    const [selectedDepositToken, setSelectedDepositToken] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [selectedWithdrawToken, setSelectedWithdrawToken] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const isP2pSupported = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((tokenSymbol)=>fiatTokensList.some((fiatToken)=>tokenSymbol === fiatToken.symbol), [
        fiatTokensList
    ]);
    const openDepositModal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((token)=>{
        setSelectedDepositToken(token);
    }, [
        setSelectedDepositToken
    ]);
    const openWithdrawModal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((token)=>{
        setSelectedWithdrawToken(token);
    }, [
        setSelectedWithdrawToken
    ]);
    const closeMethodSelectionDialog = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setSelectedDepositToken(null);
        setSelectedWithdrawToken(null);
    }, []);
    const onClickMethod = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((type)=>{
        if (type === _components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__/* .METHOD_TYPE.network */ .z.network) {
            selectedDepositToken && setDepositToken(selectedDepositToken);
            selectedWithdrawToken && setWithdrawToken(selectedWithdrawToken);
        }
        if (type === _components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__/* .METHOD_TYPE.bank */ .z.bank) {
            selectedDepositToken && (isP2pSupported(selectedDepositToken.symbol) ? router.push("/buy/".concat(selectedDepositToken.symbol)) : router.push("/reVND_".concat(selectedDepositToken.symbol)));
            selectedWithdrawToken && (isP2pSupported(selectedWithdrawToken.symbol) ? router.push("/sell/".concat(selectedWithdrawToken.symbol)) : router.push("/".concat(selectedWithdrawToken.symbol, "_reVND")));
        }
        closeMethodSelectionDialog();
    }, [
        router,
        selectedDepositToken,
        selectedWithdrawToken,
        setDepositToken,
        setWithdrawToken,
        closeMethodSelectionDialog,
        isP2pSupported
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return {
            openDepositModal,
            openWithdrawModal,
            setSelectedDepositToken,
            setSelectedWithdrawToken,
            rendered: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                onClose: closeMethodSelectionDialog,
                selectedDepositToken: selectedDepositToken,
                selectedWithdrawToken: selectedWithdrawToken,
                onClick: onClickMethod,
                isP2pSupported: isP2pSupported
            })
        };
    }, [
        closeMethodSelectionDialog,
        isP2pSupported,
        onClickMethod,
        openDepositModal,
        openWithdrawModal,
        selectedDepositToken,
        selectedWithdrawToken
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAssetsMethodSelectionFlow);


/***/ }),

/***/ 86879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_defaults__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91747);
/* harmony import */ var lodash_defaults__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_defaults__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78718);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





/**
 * An alternative for Next's {@link https://nextjs.org/docs/app/api-reference/functions/use-search-params | useSearchParams}
 * that supports clustering and mutating search parameters.
 */ const useMutableSearchParams = (initialParams)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [baseURI, searchParams] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const [baseURI, searchString] = router.asPath.split("?");
        return [
            baseURI,
            new URLSearchParams(searchString)
        ];
    }, [
        router.asPath
    ]);
    const [defaultParams, setDefaultParams] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(initialParams);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setDefaultParams((defaultParams)=>lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(defaultParams, initialParams) ? defaultParams : initialParams);
    }, [
        initialParams
    ]);
    const filterByDefaultParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((obj)=>defaultParams ? lodash_pick__WEBPACK_IMPORTED_MODULE_2___default()(obj, Object.keys(defaultParams)) : obj, [
        defaultParams
    ]);
    const params = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const searchParamObj = Object.fromEntries(searchParams.entries());
        const filteredParamObj = lodash_defaults__WEBPACK_IMPORTED_MODULE_0___default()(filterByDefaultParams(searchParamObj), defaultParams);
        return new Proxy(filteredParamObj, {
            get (target, p, receiver) {
                return p in target ? Reflect.get(target, p, receiver) : null;
            }
        });
    }, [
        defaultParams,
        filterByDefaultParams,
        searchParams
    ]);
    const getMergedSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((stateToBeMerged)=>{
        const newSearchParams = new URLSearchParams([
            ...searchParams.entries()
        ]);
        for (const [key, value] of Object.entries(filterByDefaultParams(stateToBeMerged))){
            if (value) {
                newSearchParams.set(key, value === true ? "" : value);
            } else {
                newSearchParams.delete(key);
            }
        }
        return newSearchParams;
    }, [
        filterByDefaultParams,
        searchParams
    ]);
    const pushState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(stateToBeMerged) {
        let shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const newSearchParams = getMergedSearchParams(stateToBeMerged);
        router.push({
            pathname: baseURI,
            search: newSearchParams.toString()
        }, undefined, {
            shallow
        });
    }, [
        baseURI,
        getMergedSearchParams,
        router
    ]);
    const replaceState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(stateToBeMerged) {
        let shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const newSearchParams = getMergedSearchParams(stateToBeMerged);
        router.replace({
            pathname: baseURI,
            search: newSearchParams.toString()
        }, undefined, {
            shallow
        });
    }, [
        baseURI,
        getMergedSearchParams,
        router
    ]);
    return {
        params,
        pushState,
        replaceState
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMutableSearchParams);


/***/ })

}]);